// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1Kasr","info":"PatientInfo_info__ivg-Z"};